import { memo } from "react";
import { Outlet } from "react-router-dom";
import SideNavTwo from "../pages/components/SideNavTwo";
export default memo(() => {
  return (
    <>
    <SideNavTwo/>
    </>
  );
});